
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-6">
              America Discovery Travel & Transport LLC
            </h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              Dịch vụ vận tải du lịch cao cấp tại Hoa Kỳ, phục vụ các công ty du lịch Việt Nam với chất lượng chuẩn Mỹ.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/phunggiatuan" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-blue-600 hover:bg-blue-700 rounded-full transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-blue-400 hover:bg-blue-500 rounded-full transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="https://www.youtube.com/@DuLichKhamPhaMy" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-red-600 hover:bg-red-700 rounded-full transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a href="https://www.facebook.com/phunggiatuan" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-pink-600 hover:bg-pink-700 rounded-full transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Dịch vụ</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://www.usaroadtrip.club" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Tour Phượt Mỹ
                </a>
              </li>
              <li>
                <a href="https://uslandtour.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Driver Guide
                </a>
              </li>
              <li>
                <a href="https://uslandtour.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Combo Tour
                </a>
              </li>
              <li>
                <a href="https://uslandtour.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Đối tác du lịch
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">Liên hệ</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-phone-fill text-xl mr-3 mt-1 text-blue-400"></i>
                <div>
                  <p className="font-semibold">Hotline</p>
                  <p className="text-gray-400">+1 714 552 1068</p>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-fill text-xl mr-3 mt-1 text-blue-400"></i>
                <div>
                  <p className="font-semibold">Email</p>
                  <a href="mailto:americadiscoverytravel@gmail.com" className="text-gray-400 hover:text-white transition-colors">
                    americadiscoverytravel@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-global-fill text-xl mr-3 mt-1 text-blue-400"></i>
                <div>
                  <p className="font-semibold">Website</p>
                  <p className="text-gray-400">americabusline.com</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Office Locations */}
          <div>
            <h4 className="text-lg font-bold mb-6">Văn phòng</h4>
            <div className="space-y-4">
              <div>
                <p className="font-semibold mb-2">
                  <i className="ri-map-pin-fill text-blue-400 mr-2"></i>
                  Văn phòng Mỹ
                </p>
                <p className="text-gray-400 text-sm">
                  721 S Susan st, Santa Ana<br />
                  CA 92704, United States
                </p>
              </div>
              <div>
                <p className="font-semibold mb-2">
                  <i className="ri-map-pin-fill text-blue-400 mr-2"></i>
                  Văn phòng Việt Nam
                </p>
                <p className="text-gray-400 text-sm">
                  37 Hoàng Văn Thái<br />
                  Hà Nội, Việt Nam
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 America Discovery Travel & Transport LLC. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                Chính sách bảo mật
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
                Điều khoản sử dụng
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 flex items-center justify-center bg-blue-900 hover:bg-blue-800 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer z-50"
        aria-label="Scroll to top"
      >
        <i className="ri-arrow-up-line text-2xl"></i>
      </button>
    </footer>
  );
}
